module.exports = __webpack_public_path__ + "static/media/Angela_Ferrari_06.28fad9d5.jpg";